import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatPercent, formatVolume } from '../../../utils/numberFormatFunc';
import styles from '../OptionsBoardStyles';

const BasicCallBoardModalDesktop = (props) => {
  const { state, keyName } = props;
  const { activeRow } = state;
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const { width, ticker, expiration } = appReducer;
  const { modalDate } = optionChainReducer;

  const isDesktop = width > 850 ? true : false;
  return isDesktop ? (
    <div style={styles.boardModalData}>
      <h2 style={{ marginBottom: 0, marginTop: 20 }}>Options Trade</h2>
      <div style={{ color: 'gray', marginBottom: '20px' }}>
        {moment(modalDate).format('MMM DD YYYY')}
      </div>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: '#043055' }}>
            <TableCell
              style={{ color: 'white', fontSize: 18, width: '40%' }}
              align="center"
            >
              OPTION
            </TableCell>
            <TableCell
              style={{ color: 'white', fontSize: 18, width: '10%' }}
              align="center"
            >
              VOL
            </TableCell>
            <TableCell
              style={{ color: 'white', fontSize: 18, width: '10%' }}
              align="center"
            >
              OI
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: 18 }} align="center">
              IVOL
            </TableCell>
            <TableCell style={{ color: 'white', fontSize: 18 }} align="center">
              CHG
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={ticker}>
            <TableCell style={{ fontSize: 18, width: '40%' }} align="center">
              {ticker +
                ' ' +
                moment(expiration).format('DD-MMM-YY') +
                ' $' +
                activeRow.strike +
                ` ${keyName}`}
            </TableCell>
            <TableCell style={{ fontSize: 18, width: '10%' }} align="center">
              {formatVolume(activeRow.volume)}
            </TableCell>
            <TableCell style={{ fontSize: 18, width: '10%' }} align="center">
              {formatVolume(activeRow.open_int)}
            </TableCell>
            <TableCell align="center" style={{ fontSize: 18, width: '10%' }}>
              {formatPercent(activeRow.ivol)}%
            </TableCell>
            <TableCell align="center" style={{ fontSize: 18, width: '10%' }}>
              <span
                style={
                  activeRow.ivol_chg > 0 ? { color: 'green' } : { color: 'red' }
                }
              >
                {activeRow.ivol_chg > 0
                  ? '+' +
                    (Math.round(activeRow.ivol_chg * 1000) / 10).toFixed(1)
                  : (Math.round(activeRow.ivol_chg * 1000) / 10).toFixed(1)}
              </span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  ) : (
    ''
  );
};

export default BasicCallBoardModalDesktop;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard/BasicCallBoardModalDesktop.jsx